export default __webpack_public_path__ + "static/media/mortgage.2637e5be.png";